import React, { useState, useEffect } from "react";
import Select from "react-select";
import AirportServices from "services/AirportServices";

const SelectSingleAirportId = ({
  register,
  selectedCity,
  handleCityChange,
  handleCityChangeName,
  name,
  label,
  readonly,
}) => {
  const [airports, setSingleAirport] = useState([]);
 const customSelectStyles = {
  control: (base, state) => ({
    ...base,
    border: "1px",
    boxShadow: "none",
    backgroundColor: state.isDisabled ? "#E2E8F0" : "#FFFFFF",
    cursor: state.isDisabled ? "not-allowed" : "default",
  }),
  option: (provided, state) => ({
    ...provided,
    background: state.isSelected
      ? "#0e9f6e"
      : state.isFocused
      ? "rgba(0, 0, 0, 0.15)"
      : "white",
    color: state.isSelected ? "white" : "black",
    "&:hover": {
      background: "rgba(0, 0, 0, 0.15)",
      color: "black",
    },
  }),
  menu: (provided, state) => ({
    ...provided,
    margin: "10px 0 -10px 0",
  }),
  indicatorSeparator: () => ({
    display: "none",
  }),

  //  Clear the color from selected value
  singleValue: (provided) => ({
    ...provided,
    color: "inherit", // or remove this line entirely if you want to use inherited/default styling
  }),
};

  useEffect(() => {
    let isMounted = true; // Add this variable to track the component's mounting state

    async function fetchAirport() {
      try {
        const response = await AirportServices.getAllAirport();
        const transformedData = response.data.map((item) => ({
          value: item.id_city,
          label: item.airportname,
          cityname: item.cityname,
        }));

        // Check if the component is still mounted before updating the state
        if (isMounted) {
          setSingleAirport(transformedData);
        }
      } catch (error) {
        console.error("Error fetching airports:", error);
      }
    }

    fetchAirport();

    // Cleanup function to set isMounted to false when the component is unmounted
    return () => {
      isMounted = false;
    };
  }, []);

  const handleCitySelect = async (selected) => {
    const item = airports.find((item) => item.value === selected.value);
    if (item) {
      handleCityChange(selected.value);
      if (handleCityChangeName) {
        handleCityChangeName(selected.cityname);
      }
    }
  };

  return (
    <Select
      className="dark:text-white-300 leading-5 rounded-md focus:border-white-200 border-gray-200 dark:border-gray-600 focus:ring focus:ring-green-300 dark:focus:border-gray-500 dark:focus:ring-gray-300 dark:bg-gray-700 border h-10 text-sm focus:outline-none block w-full bg-white-100 border-transparent focus:bg-white"
      // isSearchable={false}
      {...register(`${name}`, {
        required: !selectedCity ? `${label} is required!` : false,
      })}
      // defaultValue={selectedCity}
      name={name}
      styles={customSelectStyles}
      options={airports}
      isDisabled={readonly}
      onChange={(e) => handleCitySelect(e)}
      value={
        selectedCity
          ? airports.find(
              (option) => String(option.value) === String(selectedCity)
            )
          : null
      }
    />
  );
};

export default SelectSingleAirportId;
